import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Button from 'components/common/Button/Button'

const SKU_ID = 'sku4070587'
// // const STAGGERED_SKU_ID = '3960002_4160038_4160051_2254517_2454517'


const Test = ({ showFindLowerPriceModal }) =>
  <>
    <CustomButton onClick={ () => showFindLowerPriceModal(SKU_ID) }>
      Found lower? Let us know link
    </CustomButton>

    {/* <div dangerouslySetInnerHTML={{ __html: content }} /> */}
  </>

Test.propTypes = {
  showFindLowerPriceModal: PropTypes.func
}

export default Test

const CustomButton = styled(Button)`
  margin-top: 100px;
`
